(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comparison-page"]) return;
  try {
    
  (function() {
    const COMPARE_KEY = 'compare_products';
    const SLOTS = 4;

    // key can be a string OR an array of fallback keys (first non-empty wins).
    // Fallback arrays merge synonym / typo variants across metaobjects.
    const FIELDS = [
      { section: 'Camera', rows: [
        { key: 'optical_zoom', label: 'Optical Zoom' },
        { key: ['image_sensor', 'sensor'], label: 'Image Sensor' },
        { key: 'effective_pixels', label: 'Effective Pixels' },
        { key: 'video_signals', label: 'Video Signals' },
        { key: 'video_resolution', label: 'Video Resolution' },
        { key: 'lens_aperture', label: 'Lens & Aperture' },
        { key: 'aperture_brightness_contrast', label: 'Aperture / Brightness / Contrast' },
        { key: 'digital_zoom', label: 'Digital Zoom' },
        { key: 'zoom_speed', label: 'Zoom Speed' },
        { key: 'focal_length', label: 'Focal Length' },
        { key: 'shortest_shooting_distance', label: 'Shortest Shooting Distance' },
        { key: 'field_of_view', label: 'Field of View' },
        { key: 'horizontal_angel', label: 'Horizontal Angle' },
        { key: 'vertical_angel', label: 'Vertical Angle' },
        { key: 'diagonal_angle', label: 'Diagonal Angle' },
        { key: 'ai_support', label: 'AI Support' },
        { key: 'ai_mode', label: 'AI Mode' },
        { key: 'minimum_illumination', label: 'Minimum Illumination' },
        { key: 'shutter', label: 'Shutter' },
        { key: 'white_balance', label: 'White Balance' },
        { key: 'backlight_compensation', label: 'Backlight Compensation' },
        { key: 'digital_noice_reduction', label: 'Digital Noise Reduction' },
        { key: 'exposure', label: 'Exposure' },
        { key: 'foucs', label: 'Focus' },
        { key: 'video_encoding_format', label: 'Video Encoding Format' },
        { key: 'color_space_compression', label: 'Color Space Compression' },
        { key: 'video_format', label: 'Video Format' },
        { key: 'frame_rate', label: 'Frame Rate' },
        { key: 'resolution', label: 'Resolution' },
        { key: 'input_resolution', label: 'Input Resolution' },
        { key: 'output_resolution', label: 'Output Resolution' },
        { key: 'video_sampling', label: 'Video Sampling' },
        { key: 'screen', label: 'Screen' },
        { key: 'display', label: 'Display' },
        { key: 'four_split_display', label: 'Four-split Display' },
        { key: 'split_screen_display', label: 'Split Screen Display' },
        { key: 'camera_control', label: 'Camera Control' },
        { key: 'max_camera_control', label: 'Max Camera Control' },
        { key: 'pan_rotation', label: 'Pan Rotation' },
        { key: 'tilt_rotation', label: 'Tilt Rotation' },
        { key: 'auto_flip', label: 'Auto Flip' },
        { key: 'image_freeze', label: 'Image Freeze' },
        { key: 'eptz', label: 'ePTZ' },
        { key: 'preset_positions', label: 'Preset Positions' },
        { key: 'preset_accuracy', label: 'Preset Accuracy' },
        { key: 'preset_call_up_speed', label: 'Preset Call-up Speed' },
        { key: ['snr', 'signal_to_noise_ratio'], label: 'SNR' },
        { key: 'audio_compression', label: 'Audio Compression' },
        { key: 'audio_bit_rate', label: 'Audio Bit Rate' },
        { key: 'audio_delay', label: 'Audio Delay' },
        { key: 'audio_processing', label: 'Audio Processing' },
        { key: 'built_in_mic', label: 'Built-in Mic' },
        { key: 'voice_pickup_range', label: 'Voice Pickup Range' },
        { key: 'built_in_speaker', label: 'Built-in Speaker' },
        { key: 'mics', label: 'Mics' },
        { key: 'microphone_type', label: 'Microphone Type' },
        { key: 'microphone_sensitivity', label: 'Microphone Sensitivity' },
        { key: 'directivity', label: 'Directivity' },
        { key: 'sensitivity', label: 'Sensitivity' },
        { key: 'max_sound_pressure_level', label: 'Max. Sound Pressure Level' },
        { key: 'frequency_response', label: 'Frequency Response' },
        { key: 'speaker', label: 'Speaker' },
        { key: 'speaker_volume', label: 'Speaker Volume' },
        { key: 'noise_reduction', label: 'Noise Reduction' },
        { key: 'full_duplex_audio', label: 'Full Duplex Audio' },
        { key: 'aec', label: 'AEC' },
        { key: 'frequency_range', label: 'Frequency Range' },
        { key: 'pickup_range', label: 'Pickup Range' },
      ]},
      { section: 'Network', rows: [
        { key: 'video_compression', label: 'Video Compression' },
        { key: 'video_stream', label: 'Video Stream' },
        { key: 'main_stream_resolution', label: 'Main Stream Resolution' },
        { key: 'sub_stream_resolution', label: 'Sub Stream Resolution' },
        { key: 'bit_rate', label: 'Bit Rate' },
        { key: 'bit_rate_type', label: 'Bit Rate Type' },
        { key: 'frequency', label: 'Frequency' },
        { key: 'network_protocal', label: 'Network Protocol' },
        { key: 'network_medium', label: 'Network Medium' },
        { key: 'network_standards', label: 'Network Standards' },
        { key: 'network_latency', label: 'Network Latency' },
        { key: 'backboard_bandwidth', label: 'Backboard Bandwidth' },
        { key: 'bluetooth', label: 'Bluetooth' },
        { key: 'connection_type', label: 'Connection Type' },
      ]},
      { section: 'USB', rows: [
        { key: 'support_operating_system', label: 'Support Operating System' },
        { key: 'system_requirements', label: 'System Requirements' },
        { key: 'application_support', label: 'Application Support' },
        { key: 'usb_video_communication_protocal', label: 'USB Video Communication Protocol' },
        { key: 'uvc_ptz_control', label: 'UVC PTZ Control' },
        { key: 'usb_interface', label: 'USB Interface' },
      ]},
      { section: 'I/O Interfaces', rows: [
        { key: 'hd_output', label: 'HD Output' },
        { key: 'network_interface', label: 'Network Interface' },
        { key: 'audio_interface', label: 'Audio Interface' },
        { key: ['communication_interface2', 'communication_interface'], label: 'Communication Interface' },
        { key: 'sd_card', label: 'SD Card' },
        { key: 'restore_button', label: 'Restore Button' },
        { key: 'power_interface', label: 'Power Interface' },
        { key: 'interface', label: 'Interface' },
        { key: 'input', label: 'Input' },
        { key: 'output', label: 'Output' },
        { key: 'control', label: 'Control' },
        { key: 'data_pin', label: 'Data Pin' },
        { key: 'connector', label: 'Connector' },
        { key: 'joystick', label: 'Joystick' },
        { key: 'battery', label: 'Battery' },
        { key: 'poe', label: 'PoE' },
        { key: 'poe_output_power', label: 'PoE Output Power' },
        { key: 'poe_power', label: 'PoE Power' },
        { key: 'poe_power_consumption', label: 'PoE Power Consumption' },
        { key: ['led_indicators', 'led_indicator'], label: 'LED Indicators' },
        { key: 'remote_control', label: 'Remote Control' },
        { key: 'cable_length', label: 'Cable Length' },
        { key: 'camera_angle_adjustment', label: 'Camera Angle Adjustment' },
        { key: 'magnetic_privacy_cover', label: 'Magnetic Privacy Cover' },
      ]},
      { section: 'General', rows: [
        { key: 'input_voltage', label: 'Input Voltage' },
        { key: 'input_current', label: 'Input Current' },
        { key: 'input_power', label: 'Input Power' },
        { key: 'constant_power', label: 'Constant Power' },
        { key: 'power', label: 'Power' },
        { key: 'power_supply', label: 'Power Supply' },
        { key: 'power_supply_type', label: 'Power Supply Type' },
        { key: 'power_consumption', label: 'Power Consumption' },
        { key: 'overload_current_protection', label: 'Overload Current Protection' },
        { key: ['operating_temperature', 'working_temperature', 'work_temperature'], label: 'Operating Temperature' },
        { key: ['operating_humidity', 'working_humidity', 'work_humidity'], label: 'Operating Humidity' },
        { key: 'storage_temperature', label: 'Storage Temperature' },
        { key: 'storage_humidity', label: 'Storage Humidity' },
        { key: ['dimension_before_after_package', 'dimension_beofore_after_package'], label: 'Dimension (Before/After Package)' },
        { key: 'unit_dimensions', label: 'Unit Dimensions' },
        { key: 'net_gross_weight', label: 'Net/Gross Weight' },
        { key: 'net_weight', label: 'Net Weight' },
        { key: 'gross_weight', label: 'Gross Weight' },
        { key: 'mounting_bracket', label: 'Mounting Bracket' },
        { key: 'meeting_room_size_for_single_speakerphone', label: 'Meeting Room Size' },
        { key: 'meeting_with_single_speakerphone', label: 'Meeting Support' },
      ]},
      { section: 'Others', rows: [
        { key: 'chip', label: 'Chip' },
        { key: ['package_includes', 'package_contents'], label: 'Package Includes' },
        { key: 'max_equipment', label: 'Max Equipment' },
        { key: 'decoding', label: 'Decoding' },
        { key: 'decoding_capability', label: 'Decoding Capability' },
        { key: ['protocol', 'protocols'], label: 'Protocol' },
        { key: 'user_interfaces', label: 'User Interfaces' },
        { key: 'accessories', label: 'Accessories' },
        { key: 'beep', label: 'Beep' },
        { key: 'system1', label: 'System' },
        { key: 'system_latency', label: 'System Latency' },
        { key: 'storage', label: 'Storage' },
        { key: 'audio', label: 'Audio' },
        { key: 'address_database_table_size', label: 'Address Database Table Size' },
        { key: 'buffer_memory', label: 'Buffer Memory' },
        { key: 'processing_types', label: 'Processing Types' },
      ]},
    ];

    function renderStars(rating) {
      const full = Math.floor(rating);
      const half = rating % 1 >= 0.5 ? 1 : 0;
      const empty = 5 - full - half;
      return '★'.repeat(full) + (half ? '☆' : '') + '☆'.repeat(empty);
    }

    function getList() {
      return JSON.parse(localStorage.getItem(COMPARE_KEY) || '[]');
    }

    function buildCard(p, i) {
      if (!p) return '<div class="comp-card comp-card--empty"></div>';
      return `
        <div class="comp-card">
          <button class="comp-card__remove" onclick="removeProduct(${i})" aria-label="Remove">✕</button>
          <div class="comp-card__img-wrap">
            <img src="${p.image}" alt="${p.title}">
            ${p.available !== false ? `
            <quick-add-component class="quick-add quick-add-custom color-scheme-1 comp-card__quick-add" ref="quickAdd" data-product-title="${p.title}" data-quick-add-button="add" data-product-options-count="1">
              <product-form-component data-section-id="" data-product-id="${p.product_id || p.id || ''}" on:submit="/handleSubmit" class="quick-add__product-form-component">
                <div class="visually-hidden" aria-live="assertive" role="status" aria-atomic="true" ref="liveRegion"></div>
                <form method="post" action="/cart/add" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                  <input type="hidden" name="form_type" value="product">
                  <input type="hidden" name="utf8" value="✓">
                  <input type="hidden" name="id" ref="variantId" value="${p.variant_id}">
                  <input type="hidden" name="quantity" value="1">
                  <add-to-cart-component ref="addToCartButtonContainer" data-product-variant-media="${p.image}" data-add-to-cart-animation="true">
                    <button type="submit" name="add" ref="addToCartButton" on:click="/handleClick" class="button button quick-add__button quick-add__button--add add-to-cart-button">
                      <span class="add-to-cart-text">
                        <span aria-hidden="true" class="svg-wrapper add-to-cart-icon">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle>
                            <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                          </svg>
                        </span>
                        <span class="add-to-cart-text__content is-visually-hidden-mobile">
                          <span><span>Add</span></span>
                        </span>
                      </span>
                      <span class="add-to-cart__added">
                        <span class="svg-wrapper add-to-cart__added-icon">
                          <svg aria-hidden="true" class="checkmark-burst" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g class="check">
                              <circle class="ring" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></circle>
                              <path class="tick" d="M9 12.75L11.25 15L15 9.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                            </g>
                            <g class="burst">
                              <g style="--index: 0;"><line class="line" stroke-linecap="round" pathLength="1" x1="12" y1="8.5" x2="12" y2="15.5" stroke="currentColor"></line></g>
                              <g style="--index: 1;"><line class="line" stroke-linecap="round" pathLength="1" x1="12" y1="8.5" x2="12" y2="15.5" stroke="currentColor"></line></g>
                              <g style="--index: 2;"><line class="line" stroke-linecap="round" pathLength="1" x1="12" y1="8.5" x2="12" y2="15.5" stroke="currentColor"></line></g>
                              <g style="--index: 3;"><line class="line" stroke-linecap="round" pathLength="1" x1="12" y1="8.5" x2="12" y2="15.5" stroke="currentColor"></line></g>
                              <g style="--index: 4;"><line class="line" stroke-linecap="round" pathLength="1" x1="12" y1="8.5" x2="12" y2="15.5" stroke="currentColor"></line></g>
                              <g style="--index: 5;"><line class="line" stroke-linecap="round" pathLength="1" x1="12" y1="8.5" x2="12" y2="15.5" stroke="currentColor"></line></g>
                              <g style="--index: 6;"><line class="line" stroke-linecap="round" pathLength="1" x1="12" y1="8.5" x2="12" y2="15.5" stroke="currentColor"></line></g>
                              <g style="--index: 7;"><line class="line" stroke-linecap="round" pathLength="1" x1="12" y1="8.5" x2="12" y2="15.5" stroke="currentColor"></line></g>
                            </g>
                          </svg>
                        </span>
                      </span>
                    </button>
                  </add-to-cart-component>
                  <input type="hidden" name="product-id" value="${p.product_id || p.id || ''}">
                </form>
              </product-form-component>
            </quick-add-component>` : ''}
          </div>
          <div class="comp-card-info">
              <div class="comp-card__title">${p.title}</div>        
              <div class="comp-card__price"><span class="comp-card__price-label">You Pay:</span> ${p.price}</div>
              <div class="comp-card__rating">
              <span>${renderStars(4.8)}</span>
              <span class="rating_value">4.8/5</span>
              </div>
              ${p.available !== false
              ? `<button class="comp-card__btn" onclick="window.location.href='${p.url}'">Shop Now</button>`
              : `<button class="comp-card__btn comp-card__btn--soldout" disabled>Sold Out</button>`
              }
          </div>
        </div>`;
    }

    function renderTable(list) {
      const el = document.getElementById('comp-table');
      if (!el) return;

      let html = '<table class="comp-table">';

      // 卡片行：放到 thead 里，第 1 个 td 留空，后面 4 个放产品卡片
      html += '<thead>';
      html += '<tr class="comp-cards-row"><th></th>';
      for (let i = 0; i < SLOTS; i++) {
        html += `<td>${buildCard(list[i], i)}</td>`;
      }
      html += '</tr>';
      html += '</thead>';

      html += '<tbody>';

      const pickVal = (product, key) => {
        const keys = Array.isArray(key) ? key : [key];
        for (const k of keys) {
          const v = product[k];
          if (v !== undefined && v !== null && v !== '') return v;
        }
        return '';
      };

      FIELDS.forEach(group => {
        const rowsHtml = group.rows.map(row => {
          const cells = [];
          let hasValue = false;
          for (let i = 0; i < SLOTS; i++) {
            const val = list[i] ? pickVal(list[i], row.key) : '';
            if (val) hasValue = true;
            cells.push(list[i] ? (val || '—') : '');
          }
          if (!hasValue) return '';
          return `<tr><th>${row.label}</th>${cells.map(c => `<td>${c}</td>`).join('')}</tr>`;
        }).filter(Boolean).join('');

        if (!rowsHtml) return;

        html += `<tr class="section-header"><th>${group.section}</th>`;
        for (let i = 0; i < SLOTS; i++) html += '<td></td>';
        html += '</tr>';
        html += rowsHtml;
      });

      html += '</tbody></table>';
      el.innerHTML = html;
    }

    function render() {
      renderTable(getList());
    }

    window.removeProduct = function(index) {
      const list = getList();
      list.splice(index, 1);
      localStorage.setItem(COMPARE_KEY, JSON.stringify(list));
      render();
    };

    document.addEventListener('DOMContentLoaded', render);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
